import {useState, useEffect} from 'react'
import {getAiEmail} from '../modules/recordskeeper-ai/core/_requests'
import {useAuth} from '../modules/auth'
import {toast} from 'react-toastify'

export const useSettingsData = () => {
  const [fileLimits, setFileLimits] = useState([
    {name: '', type: 'FILE', maxFileSizeValue: '', maxFileSize: ''},
  ])
  const [fileLimits2, setFileLimits2] = useState([
    {name: '', type: 'FILE', retentionValue: '', retentionPeriod: ''},
  ])
  const [aiEmailLoading, setAiEmailLoading] = useState<boolean>(false)
  const [settingsData, setSettingData] = useState<any>()
  const [notificationData, setNotificationData] = useState<any>()
  const {companyId} = useAuth()

  const fetchAiEmailData = async () => {
    if (!companyId) return
    setAiEmailLoading(true)

    try {
      const {
        data: {data, success, errors},
      } = await getAiEmail(companyId)

      if (success) {
        setSettingData(data)
        setNotificationData(data?.notificationDatas)

        const filteredFileLimits = (data?.recordKeeperRetentionDetails || [])
          .filter((item: any) => item.name && item.maxFileSizeValue && item.maxFileSize)
          .map((item: any) => ({
            id: item.recordRetentionId,
            name: item.name,
            type: item.type,
            maxFileSizeValue: item.maxFileSizeValue,
            maxFileSize: item.maxFileSize,
          }))

        setFileLimits(filteredFileLimits.length > 0 ? filteredFileLimits : [])
        const filteredFileLimits2 = (data?.recordKeeperRetentionDetails || [])
          .filter(
            (item: any) =>
              item.name && item.retentionPeriod && item.retentionValue && item.type === 'FILE'
          )
          .map((item: any) => ({
            id: item.recordRetentionId,
            name: item.name,
            type: item.type,
            retentionPeriod: item.retentionPeriod,
            retentionValue: item.retentionValue,
          }))
        setFileLimits2(filteredFileLimits2)
      } else {
        toast.error(errors.name)
      }
    } catch (err) {
      console.error(err)
    } finally {
      setAiEmailLoading(false)
    }
  }

  const fetchAiEmailDataWithoutLoader = async () => {
    if (!companyId) return

    try {
      const {
        data: {data, success, errors},
      } = await getAiEmail(companyId)

      if (success) {
        setSettingData(data)
        setNotificationData(data?.notificationDatas)

        const filteredFileLimits = (data?.recordKeeperRetentionDetails || [])
          .filter((item: any) => item.name && item.maxFileSizeValue && item.maxFileSize)
          .map((item: any) => ({
            id: item.recordRetentionId,
            name: item.name,
            type: item.type,
            maxFileSizeValue: item.maxFileSizeValue,
            maxFileSize: item.maxFileSize,
          }))

        setFileLimits(filteredFileLimits.length > 0 ? filteredFileLimits : [])
        const filteredFileLimits2 = (data?.recordKeeperRetentionDetails || [])
          .filter(
            (item: any) =>
              item.name && item.retentionPeriod && item.retentionValue && item.type === 'FILE'
          )
          .map((item: any) => ({
            id: item.recordRetentionId,
            name: item.name,
            type: item.type,
            retentionPeriod: item.retentionPeriod,
            retentionValue: item.retentionValue,
          }))
        setFileLimits2(filteredFileLimits2)
      } else {
        toast.error(errors.name)
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchAiEmailData()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    settingsData,
    fileLimits,
    aiEmailLoading,
    fetchAiEmailData,
    setFileLimits,
    notificationData,
    fileLimits2,
    setFileLimits2,
    fetchAiEmailDataWithoutLoader
  }
}
